import { useState } from "react";

import Window from "./components/window.js";

import Player from "./components/player.js";
import Map from "./components/map.js";

function App() {

  const AppWrapper = () => {

    const fetchImageData = () => {
      if (localStorage.getItem('activeImage') !== null) {
        document.getElementById("panmap").click()
      }
    }

    const MasterMediaPlayer = () => {

      const [mediadata, setMediadata] = useState({type: "image", short: "Loading...", source: "/images/bgs/progress.gif"})

      const openMediaPlayer = () => {
        setMediadata({type: "image", short: "", source: sessionStorage.getItem('fileroute'), win7id: sessionStorage.getItem('win7id')});
        document.getElementById('master-mediaplayer').style.display = 'block';
      }

      const exitMediaPlayer = () => {
        setMediadata({type: "image", short: "", source: "", win7id: sessionStorage.getItem('win7id')});
        document.getElementById('master-mediaplayer').style.display = 'none';
      }
      
      return (
        <div id="master-mediaplayer" style={{position: 'absolute', width: '100vw', height: '100vh', zIndex: 10000, display: 'none'}} className="media-player aero-border">
          <Window exittype={2} window={<Player imgdata={mediadata} newtab={true} thumb={false}/>} title={"Windows Media Player"} iconpath={"/images/bgs/mediaplayer.png"} />
          <button id="mediaplayer-open" style={{display: 'none'}} onClick={() => openMediaPlayer()}></button>
          <button id="mediaplayer-exit" style={{display: 'none'}} onClick={() => exitMediaPlayer()}></button>
        </div>
      )
    }

    return (
      <>
        <div className="map-main">
          <Map/>
        </div>
        <MasterMediaPlayer/>
        <button id="fetchImageData" style={{display: 'none'}} onClick={() => fetchImageData()} ></button>
      </>
    )
  }

  return (
    <div className="new-desktop">
      <AppWrapper/>
    </div>
  );
}

export default App;
